import { css, unsafeCSS } from 'lit';
import { sbkCoreBreakpointLg, sbkCoreBreakpointMd } from '@/tokens/variables.js'

const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);
const breakpointMaxWidthMd = unsafeCSS(`calc(${sbkCoreBreakpointMd} - 1px)`);


export const telephoneNumberInputStyles = css`
  * {
    box-sizing: border-box;
  }

  sbk-annotation {
    margin-bottom: var(--sbkCoreSpacingXsBase);
  }
    
    .input__wrapper {
        .label__wrapper + sbk-annotation {
            margin-top: calc(var(--sbkInput3xs) * -1);
            margin-bottom: var(--sbkInput3xs);
        }
    }

  fieldset {
    border: 0;
    padding: 0;
    margin: 0;
    min-width: 0;
  }

  .row {
    display: flex;
    gap: 1rem;
    @media all and (max-width: ${breakpointMaxWidthMd}) {
      flex-wrap: wrap;
      gap: 0;
    }

    .countryCodeSelect {
      width: 50%;
      @media all and (min-width: ${breakpointLg}) {
        min-width: 238px;
        width: calc(100% / 3);
      }
      @media all and (max-width: ${breakpointMaxWidthMd}) {
        width: 100%;
      }
    }

    .nationalNumberInput {
      width: 50%;
      @media all and (min-width: ${breakpointLg}) {
        width: calc(100% * 2 / 3);
      }
      @media all and (max-width: ${breakpointMaxWidthMd}) {
        width: 100%;
      }
    }
  }

    .among-each-other {
        flex-direction: column;
        gap: 0;
    }
`;